import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, profile, loading } = useAuth()

  if (loading) {
    return (
      <div style={styles.loading}>
        <div style={styles.logoMark}>PG</div>
        <div style={styles.loadingText}>LOADING...</div>
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  // Block deactivated users
  if (profile && profile.is_active === false) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles && profile && !allowedRoles.includes(profile.role)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}

const styles = {
  loading: {
    minHeight: '100vh',
    backgroundColor: '#0a0f1a',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    fontFamily: "'Barlow', sans-serif",
  },
  logoMark: {
    width: '60px',
    height: '60px',
    backgroundColor: '#b48c3c',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontWeight: 800,
    fontSize: '22px',
    color: '#0a0f1a',
  },
  loadingText: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: '13px',
    letterSpacing: '4px',
    color: 'rgba(255,255,255,0.3)',
  },
}
